export class AdjustmentSearchModel {
    constructor(
        
        public commissionPeriod: number,
        public sales_rep_channel:string,
        public commission_plan: number           
    ) { }
}
